<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__scopecitycompany}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.companyId"  clearable placeholder="请选择公司">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:scopecity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:scopecity:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
<!--        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="scopeCityId" label="落地城市主表ID" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="companyName" label="公司" header-align="center" align="center"></el-table-column>
        <el-table-column prop="weight" label="权重" header-align="center" align="center"></el-table-column>
        <el-table-column prop="avgPrice" label="城市昨日平均单价" header-align="center" align="center"></el-table-column>
        <el-table-column prop="assignPersonCount" label="分配人数" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="status" label="状态（开1、关0）" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:scopecity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:scopecity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './scopecitycompany-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        createdIsNeed: false,
        getDataListURL: '/sys/scopecitycompany/page',
        getDataListIsPage: true,
        exportURL: '/sys/scopecitycompany/export',
        deleteURL: '/sys/scopecitycompany',
        deleteIsBatch: true
      },
      companys:[],
      dataForm: {
        id: '',
        companyId: '',
        scopeCityId: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.dataForm.scopeCityId = this.$route.params.scopeCityId
    this.getDataList();
    this.getCompanysOptions();
  },
  methods: {
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.id = id
        this.$refs.addOrUpdate.dataForm.scopeCityId = this.dataForm.scopeCityId
        this.$refs.addOrUpdate.init()
      })
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.companys.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
